export const showLicenseAttributions = () => {
  if (document.getElementById('license-attributions-dialog')) return

  const opener = document.activeElement
  const dialog = document.createElement('dialog')
  dialog.id = 'license-attributions-dialog'
  dialog.setAttribute('aria-labelledby', 'license-attributions-title')
  dialog.setAttribute('aria-describedby', 'license-attributions-description')
  // Static shell only; third-party notice text stays in the generated document.
  dialog.innerHTML = `
    <header>
      <h2 id="license-attributions-title">License attributions</h2>
      <form method="dialog">
        <button type="submit" autofocus aria-label="Close license attributions">Close</button>
      </form>
    </header>
    <p id="license-attributions-description">
      Use Tab to move between controls and Enter to expand notices. Press Escape or Close to return to the app.
      Source links open in a new tab.
    </p>
    <p role="status" aria-live="polite" aria-atomic="true">Loading attribution document…</p>
  `
  const status = dialog.querySelector('[role="status"]') as HTMLParagraphElement

  const frame = document.createElement('iframe')
  frame.title = 'License texts and third-party attributions'
  frame.src = `${(process.env.PUBLIC_URL || '').replace(/\/$/, '')}/attributions.html`
  frame.setAttribute('aria-busy', 'true')

  let removeFrameListener = () => {}
  const onLoad = () => {
    removeFrameListener()
    frame.removeAttribute('aria-busy')
    const frameDocument = frame.contentDocument
    status.textContent = frameDocument?.title === 'License attributions'
      ? 'Attribution document loaded.'
      : 'The attribution document could not be displayed. Close this dialog and try again.'

    // Keyboard events do not bubble across iframe boundaries. Native dialog
    // focus containment remains in charge; only forward Escape from the page.
    if (!frameDocument) return
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && !event.defaultPrevented && !event.isComposing) {
        event.preventDefault()
        dialog.close()
      }
    }
    frameDocument.addEventListener('keydown', onKeyDown)
    removeFrameListener = () => frameDocument.removeEventListener('keydown', onKeyDown)
  }
  const cleanup = () => {
    frame.removeEventListener('load', onLoad)
    removeFrameListener()
    dialog.remove()
    if (opener instanceof HTMLElement && opener.isConnected) opener.focus({ preventScroll: true })
  }
  frame.addEventListener('load', onLoad)
  dialog.addEventListener('close', cleanup, { once: true })
  dialog.appendChild(frame)
  document.body.appendChild(dialog)
  try {
    // showModal makes the background inert and handles initial focus, Tab
    // containment, and Escape in the outer document without custom trapping.
    dialog.showModal()
  } catch (error) {
    cleanup()
    throw error
  }
}
